/**
 * @name FloatingLabelHapi
 * @extends FloatingLabelInput
 * @desc Floating labels for HAPI fields.
 * @author kari
 * @example
 * ```
 * <floating-label-hapi>
 *  <label class="control-label">My Label</label>
 *  <div class="form-control mock-input">
 *      <iframe>...</iframe>
 *  </div>
 * </floating-label-hapi>
 * ```
 */

import $ from 'jquery';
import utility from 'helpers/utility';
import FloatingLabelInput from 'tc/modules/subcomponents/floating-label/floating-label-input';
let FloatingLabelHapi = Object.create(FloatingLabelInput);

FloatingLabelHapi.attachedCallback = function attachedCallback() {
    this.$.label = this.querySelector('.control-label');
    this.$.iframe = this.querySelector('iframe');
    this.$.div = this.querySelector('.form-control');

    this.handleClickDiv = this.handleClickDiv.bind(this);
    this.$.div.addEventListener('click', this.handleClickDiv);
    this.$.iFrameDocument = this.getIframe(this.$.iframe);
    this.$.iFrameDocument.addEventListener('click', this.handleClickDiv);

    this.state.isReady = !!(this.$.label && this.$.iframe);

    // [CHK-405] Wait until the iframe has loaded before applying label styles.
    // This prevents an unwanted animation on the label for HAPI fields.
    if (this.state.isReady) {
        this.classList.add(this.classnames.isReady);
    }
};

FloatingLabelHapi.detachedCallback = function detachedCallback() {
    if (this.state.isReady) {
        this.$.div.removeEventListener('click', this.handleClickDiv);
        this.$.iFrameDocument.removeEventListener('click', this.handleClickDiv);
        this.$ = {};
    }
};

// Exposed so we can set the focused state since HAPI fields
// rely on window.postMessage API for integration.
FloatingLabelHapi.handleFocus = function handleFocus() {
    this.state.isFocused = true;
    this.classList.add(this.classnames.isFocused);

    // FIXED popovers not hiding if a HAPI field focused
    $('.js-popover').popover('destroy');
};

FloatingLabelHapi.handleClickDiv = function handleClickDiv() {
    this.state.isFocused = true;
    this.classList.add(this.classnames.isFocused);
};

FloatingLabelHapi.getIframe = (iframe) => {
    const emptyListeners = {
        addEventListener: () => {},
        removeEventListener: () => {},
    };
    if (utility.detectIE()) {
        return emptyListeners;
    }
    return iframe
        ? iframe.contentDocument
            ? iframe.contentDocument
            : iframe.contentWindow
            ? iframe.contentWindow.document
            : emptyListeners
        : emptyListeners;
};

document.body.classList.add('floating-labels-enabled');

export default FloatingLabelHapi;
